import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Carousel from 'nuka-carousel';
import shuffle from 'lodash/shuffle';
import { withContentRect } from 'react-measure';

import Box from '../../Box';
import Flex from '../../Flex';
import Button from '../../Button';
import Image from '../../Image';

import Decision from './Decision';
import checkImage from '../../utils/checkImage';

const ActionButton = (props) => (
  <Button
    width="6em"
    px="0"
    borderRadius="0"
    {...props}
  />
);

class Decisions extends PureComponent {
  constructor(props) {
    super(props);
    this.decisions = shuffle(props.decisions.map((dec, index) => Object.assign({}, dec, { index, src: checkImage(dec.src) })));
    this.decisionLegnth = this.decisions.length;
  }

  state = {
    slideIndex: 0,
  }

  componentDidMount() {
    this.props.measure();
  }

  handleClick = (currentSlide, onNext, value) => () => {
    const { name, onChange, readOnly } = this.props;
    if (readOnly) return;
    const decision = this.decisions[currentSlide];
    if (onChange) {
      onChange({
        target: {
          value,
          name: `${name}[${decision.index}]`
        },
        persist: () => {},
      })
    }
    setTimeout(onNext)
  }

  render() {
    const { ratio, measureRef, contentRect, rightLabel, leftLabel, readOnly, decisions, value } = this.props;
    const height = contentRect.bounds.width * ratio;
    return (
      <Box ref={measureRef}>
        {readOnly ? (
          <Flex flexWrap="wrap">
            {decisions.map(({ src }, index) => {
              const checked = value[index] === '1';
              return (
                <Box
                  key={index}
                  width={[1, null, 1 / 2]}
                  p="0.5em"
                >
                  <Box
                    border="4px solid"
                    borderColor={checked ? 'primary' : 'transparent'}
                  >
                    <Image src={checkImage(src)} />
                    {checked && (
                      <Box bg="primary" color="white" textAlign="center" p="0.5em">
                        是
                      </Box>
                    )}
                  </Box>
                </Box>
              )
            })}
          </Flex>
        ): (height && (
          <Carousel
            dragging={false}
            swiping={false}
            disableKeyboardControls
            renderCenterLeftControls={({ nextSlide, currentSlide, slideCount }) => (
              <ActionButton
                key={`${currentSlide}-0`}
                type={currentSlide === slideCount - 1 ? 'submit' : 'button'}
                onClick={this.handleClick(currentSlide, nextSlide, 0)
              }>{leftLabel}</ActionButton>
            )}
            renderCenterRightControls={({ nextSlide, currentSlide, slideCount }) => (
              <ActionButton
                key={`${currentSlide}-1`}
                type={currentSlide === slideCount - 1 ? 'submit' : 'button'}
                onClick={this.handleClick(currentSlide, nextSlide, 1)}
              >{rightLabel}</ActionButton>
            )}
            renderBottomCenterControls={({ currentSlide, slideCount }) => (
              <Box transform="translateY(150%)">
                {currentSlide + 1} / {slideCount}
              </Box>
            )}
            initialSlideHeight={height}
          >
            {this.decisions.map((de) => (
              <Decision
                key={de.index}
                height={height}
                {...de}
              />
            ))}
          </Carousel>
        ))}
      </Box>
    );
  }
}

Decisions.propTypes = {
  decisions: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string,
  })).isRequired,
  name: PropTypes.string,
  rightLabel: PropTypes.string,
  leftLabel: PropTypes.string,
  ratio: PropTypes.number,
};

Decisions.defaultProps = {
  rightLabel: 'Yes',
  leftLabel: 'No',
  ratio: 3 / 4
}

export default withContentRect('bounds')(Decisions);
